module.exports = __webpack_public_path__ + "assets/img/m12.86b71f44.png";